import React, { FC, forwardRef, memo } from 'react';
import { Divider } from 'udesk-ui';
import Question from './components/Question';
import styled from 'styled-components';

const Wrapper = styled.div`
    width: 100%;
    padding: 0 50px;
`;

const Title = styled.div`
    margin: 20px 0;
    font-size: 20px;
    color: #1b6dff;
    font-weight: bold;
    text-align: center;
`;

export interface TemplateProps {
    idx?: number;
    questionType?: string;
    surveyId?: string;
    surveySubmitTime?: string;
    surveyTitle?: string;
    originSurveyTitle?: string;
    text?: string;
    originText?: string;
    textType?: 'question' | 'answer';
    isLast?: boolean;
    isFirst?: boolean;
    isOriginText?: boolean;
}

const Template: FC<TemplateProps> = memo(
    forwardRef<any, TemplateProps>((props, ref) => {
        const {
            idx = 0,
            textType,
            questionType,
            text,
            isLast,
            surveyTitle,
            isFirst,
            originSurveyTitle,
            originText,
            isOriginText,
        } = props;

        const _surveyTitle = isOriginText ? originSurveyTitle || surveyTitle : surveyTitle;

        const _text = isOriginText ? originText || text : text;

        return (
            <Wrapper>
                {isFirst ? <Title>{_surveyTitle}</Title> : null}

                <div className="audio-call-content-view-custom-text-info-view" ref={ref}>
                    {textType === 'question' ? (
                        <Question idx={idx / 2} type={questionType} text={_text} />
                    ) : textType === 'answer' ? (
                        <span>{_text}</span>
                    ) : null}
                </div>

                {textType === 'answer' && !isLast ? (
                    <Divider dashed style={{ margin: '16px 0 20px' }} />
                ) : null}
            </Wrapper>
        );
    })
);

export default Template;
